import * as React from "react";
import {useEffect} from "react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import {Hidden} from "@material-ui/core";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {useDispatch, useSelector} from "react-redux";
import {hideMenu} from "../../store/global/global-slice";
import {RootState} from "../../store/root-reducer";
import {AuthMeModel} from "../../models/auth-me.model";
import {AuthService} from "../../services/auth.service";
import {AccountTypeEnum} from "../../models/account-type.enum";
import {useHistory, useLocation} from "react-router-dom";
import {StyledButton} from "./button";
import {CustomArrowDownIcon} from "./icons/custom-arrow-down-icon";
import emptyLogo from "../../img/empty-publisher-logo.png";
import {SuccessModal} from "./success-modal";
import {NotificationService} from "../../services/notification.service";
import {PaginationModel} from "../../models/pagination.model";
import {NotificationModel} from "../../models/notification.model";
import {Badge, Grid, IconButton} from "@mui/material";
import {Colors} from "../../theme/colors";
import {useTranslation} from "react-i18next";
import {ConfirmDialog} from "../confirm-dialog";
import {StyledH3, StyledP1} from "./styles";
import {CustomSettingsIcon} from "./new-icons/custom-settings-icon";
import {CustomPersonIcon} from "./new-icons/custom-person-icon";
import {CustomLogoutIcon} from "./new-icons/custom-logout-icon";
import {CustomNotificationIcon} from "./new-icons/custom-notification-icon";
import {CustomPlFlagIcon} from "./new-icons/custom-pl-flag-icon";
import {CustomEnFlagIcon} from "./new-icons/custom-en-flag-icon";

export const Header: React.FC<any> = () => {
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState<boolean>(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const [activeLang, setActiveLang] = React.useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [modalInfo, setModalInfo] = React.useState(false);
    const [blockedInfo, setBlockedInfo] = React.useState(false);
    const [notifications, setNotifications] = React.useState<PaginationModel<NotificationModel[]>>(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
    const [langAnchorEl, setLangAnchorEl] = React.useState(null);
    const [globalUnread, setGlobalUnread] = React.useState(0);
    const {t} = useTranslation('common');

    const user: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const loadNotifications = async () => {
        const res = await NotificationService.getNotifications();
        setNotifications(res);
    }

    const loadGlobalUnread = async () => {
        const res = await NotificationService.getGlobalUnread();
        setGlobalUnread(res?.unread_amount || 0);
    }

    const globalRead = async () => {
        if (globalUnread > 0) {
            await NotificationService.setGlobalRead();
            setGlobalUnread(0);
        }
    }

    useEffect(() => {
        if (user && user.account_type === AccountTypeEnum.PUB && user.status === 'AWAITING_FOR_VERIFICATION') {
            // if (location.pathname === '/dashboard') {
            //     setBlockedInfo(true);
            // }
        } else if (user && user.account_type === AccountTypeEnum.PUB && !user.publisher) {
            if (location.pathname === '/dashboard') {
                setModalInfo(true);
            }
        }

        if (user) {
            loadNotifications();
            loadGlobalUnread();

            setActiveLang(user.language);
        }
    }, [user, location.pathname]);

    const handleNotificationClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
        globalRead();
    };

    const handleNotificationClose = () => {
        setNotificationAnchorEl(null);
    };

    const handleLangClick = (event) => {
        setLangAnchorEl(event.currentTarget);
    };

    const handleLangClose = () => {
        setLangAnchorEl(null);
    };

    const langChose = (lang: 'pl' | 'en') => {
        setLangAnchorEl(null);

        if (lang !== activeLang) {
            setOpenConfirmDialog(true);
        }
    }

    const logoutAction = async () => {
        handleClose();
        await AuthService.logout();
        window.location.reload();
    }

    const getName = () => {
        switch (location.pathname) {
            case '/dashboard':
                return t('navbar.home')
            case '/author/profile':
            case '/publisher/profile':
                return t('navbar.profile')
            case '/author/add-manuscript':
                return t('navbar.addManuscript')
            case '/author/books':
                return t('navbar.myManuscripts')
            case '/publisher/manuscripts':
                return t('navbar.publishProposals')
            case '/publisher/market':
                return t('navbar.market')
            case '/publisher/edit-profile':
            case '/author/edit-profile':
                return t('navbar.editProfile')
            case '/publisher/edit-profile-first-time':
                return t('navbar.createPubProfile')
            case '/publisher/price-list':
                return t('navbar.priceList')
            case '/publisher/edit-profile-data':
                return t('navbar.editPubProfile')
            case '/publisher/my-books':
                return t('navbar.searchSimilar')
            case '/publisher/add-book':
                return t('navbar.addBook')
            case '/publisher/foreign-books':
                return t('navbar.foreignBooks')
            case '/publisher/my-books/list':
                return t('navbar.myBooks')
            case '/publisher/books-propositions':
                return t('navbar.booksPropositions')
            case '/publisher/book-market':
                return t('navbar.bookMarket')
            default:
                if (location.pathname.search('/author/publishers') !== -1) {
                    return t('navbar.pubsProfile');
                } else if (location.pathname.search('/author/book') !== -1 || location.pathname.search('/publisher/manuscript/') !== -1) {
                    return t('navbar.manDetails');
                } else if (location.pathname.search('/author/edit-manuscript/') !== -1) {
                    return t('navbar.manEdit');
                } else if (location.pathname.search('/publisher/similar-books/edit/') !== -1) {
                    return t('navbar.bookEdit');
                } else if (location.pathname.search('/publisher/similar-books/') !== -1 || location.pathname.search('/publisher/similar-books/example/') !== -1) {
                    return t('navbar.manSimilar');
                } else if (location.pathname.search('/publisher/my-books/details/') !== -1) {
                    return t('navbar.myBookDetails');
                } else if (location.pathname.search('/publisher/my-books/create') !== -1) {
                    return t('navbar.myBookCreate');
                } else if (location.pathname.search('/publisher/my-books/edit/') !== -1) {
                    return t('navbar.myBookEdit');
                } else if (location.pathname.search('/publisher/my-books/publishers') !== -1) {
                    return t('navbar.myBookPublishers');
                } else if (location.pathname.search('/publisher/book-proposition/') !== -1) {
                    return t('navbar.bookPropositionDetails');
                } else {
                    return '';
                }
        }
    }

    const notificationClicked = async (notification: NotificationModel) => {
        switch (notification.verb) {
            case 'Book_map_accepted':
            case 'opened':
            case 'downloaded_content':
            case 'downloaded_report':
            case 'bookmarked':
            case 'doesn\'t_want_to_publish':
            case 'wants_publish':
            case 'liked':
            case 'asked_for_access':
                history.push('/author/book/' + notification.action_object_object_id);
                break;
            case 'accepted_publish_offer':
            case 'rejected_publish_offer':
            case 'accepted_sharing_request':
            case 'submitted':
                history.push('/publisher/manuscript/' + notification.target_object_id);
                break;
            case 'publisher_accepted_publish_offer':
            case 'publisher_rejected_publish_offer':
            case 'publisher_accepted_sharing_request':
            case 'publisher_rejected_sharing_request':
            case 'publisher_application_submitted':
                history.push('/publisher/book-proposition/' + notification.target_object_id);
                break;
            case 'publisher_liked':
            case 'publisher_asked_for_access':
            case 'publisher_doesn\'t_want_to_publish':
            case 'publisher_wants_publish':
            case 'publisher_bookmark':
                history.push('/publisher/my-books/details/' + notification.action_object_object_id);
                break;
        }
        setNotificationAnchorEl(null);

        if (notification.unread) {
            await NotificationService.setNotificationRead(notification.id);
            loadNotifications();
        }
    }

    useEffect(() => {
        const showMenu = localStorage.getItem('showMenu');
        if (showMenu === 'false') {
            dispatch(hideMenu());
        }
    }, [dispatch]);

    return (
        <StyledHeader>
            <ConfirmDialog
                open={openConfirmDialog}
                onClose={(value) => {
                    setOpenConfirmDialog(false);

                    if (value) {
                        AuthService.updateLang(activeLang === 'en' ? 'pl' : 'en').then(() => {
                            window.location.reload();
                        });
                    }
                }}
                title={t('common:langChangeTitleConfirm')}
                text={t('common:langChangeDescConfirm')}
            />
            <StyledBoxHeader display="flex" flex={1} flexDirection="row" justifyContent="space-between"
                             alignItems="center">
                <Box flexDirection="column" display="flex">
                    <StyledH3 color={Colors.neutral20}>{getName()}</StyledH3>
                </Box>

                <Box flexDirection="row" display="flex" alignItems="center" justifyContent="center">

                    <Hidden xsDown>
                        {user && user.account_type === AccountTypeEnum.AUT && location.pathname !== '/author/add-manuscript' &&
                            <StyledButton type={"button"} color={"primary"} onClick={() => {
                                history.push('/author/add-manuscript');
                            }} style={{marginRight: '0.5rem'}}>
                                {t('navbar.addManuscript')}
                            </StyledButton>
                        }
                    </Hidden>

                    <StyledLangValue onClick={handleLangClick}>
                        {activeLang}
                        <CustomArrowDownIcon
                            style={{
                                width: '12px',
                                height: '7px',
                                marginLeft: '5px',
                                marginBottom: '2px',
                                cursor: 'pointer',
                                color: Colors.neutral80
                            }}/>
                    </StyledLangValue>
                    <Menu
                        id="lang-menu"
                        anchorEl={langAnchorEl}
                        keepMounted
                        open={Boolean(langAnchorEl)}
                        onClose={handleLangClose}
                    >
                        <StyledMenuItem onClick={() => {
                            langChose('pl')
                        }}>
                            <Grid container direction="row">
                                <CustomPlFlagIcon/>
                                <StyledP1>PL</StyledP1>
                            </Grid>
                        </StyledMenuItem>

                        <StyledMenuItem onClick={() => {
                            langChose('en')
                        }}>
                            <Grid container direction="row">
                                <CustomEnFlagIcon/>
                                <StyledP1>EN</StyledP1>
                            </Grid>
                        </StyledMenuItem>
                    </Menu>

                    <IconButton aria-label="cart" onClick={handleNotificationClick}>
                        <Badge badgeContent={globalUnread} color="error">
                            <CustomNotificationIcon/>
                        </Badge>
                    </IconButton>

                    <Menu
                        id="notification menu"
                        anchorEl={notificationAnchorEl}
                        keepMounted
                        open={Boolean(notificationAnchorEl)}
                        onClose={handleNotificationClose}
                    >
                        {notifications?.results?.map((notification, index) => (
                            <StyledMenuContainer key={index} container direction={"row"} onClick={() => {
                                notificationClicked(notification)
                            }}>
                                <StyledCircleGrid item>
                                    {notification.unread &&
                                        <StyledCircleIcon/>
                                    }
                                </StyledCircleGrid>
                                <Grid item>
                                    <StyledNotificationP>
                                        {t('notifications.' + notification.verb, {
                                            bookTitle: notification.action_object_value,
                                            authorName: notification.actor_object_value,
                                            publisherName: notification.actor_object_value
                                        })}
                                    </StyledNotificationP>
                                </Grid>
                            </StyledMenuContainer>
                        ))}
                    </Menu>

                    <Box flexDirection={"row"} display={"flex"} justifyContent={'center'} alignItems={"center"}
                         style={{marginLeft: '10px'}}>
                        {user && user.account_type === AccountTypeEnum.AUT &&
                            <StyledAuthorLogo onClick={handleClick} src={user.author?.photo?.file || emptyLogo}/>
                        }

                        {user && user.account_type === AccountTypeEnum.PUB &&
                            <StyledPublisherLogo onClick={handleClick} src={user.publisher?.logo?.file || emptyLogo}/>
                        }

                        <CustomArrowDownIcon
                            style={{
                                width: '12px',
                                height: '7px',
                                marginLeft: '5px',
                                cursor: 'pointer',
                                color: Colors.neutral80
                            }}
                            onClick={handleClick}/>
                    </Box>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <StyledMenuItem onClick={() => {
                            if (user && user.account_type === AccountTypeEnum.AUT) {
                                history.push('/author/profile');
                            } else if (user && user.account_type === AccountTypeEnum.PUB) {
                                history.push('/publisher/profile');
                            }
                            handleClose();
                        }}>
                            <CustomPersonIcon/>
                            {t('navbar.profile')}
                        </StyledMenuItem>

                        <StyledMenuItem onClick={() => {
                            history.push('/change-password');
                            handleClose();
                        }}>
                            <CustomSettingsIcon/>
                            {t('navbar.changePass')}
                        </StyledMenuItem>

                        <StyledMenuItem onClick={logoutAction}>
                            <CustomLogoutIcon/>
                            {t('logout')}
                        </StyledMenuItem>
                    </Menu>
                </Box>
            </StyledBoxHeader>

            <SuccessModal open={modalInfo} setOpen={setModalInfo} title={t('navbar.registrationSuccessModal.title')}
                          description={t('navbar.registrationSuccessModal.desc')}
                          buttonText={t('navbar.registrationSuccessModal.button')}
                          buttonLink={'/publisher/edit-profile-first-time'}/>

            <SuccessModal open={blockedInfo} setOpen={setBlockedInfo} title={t('navbar.waitingForActivate.title')}
                          description={t('navbar.waitingForActivate.desc')}
                          buttonText={t('navbar.waitingForActivate.button')}
                          buttonClick={async () => {
                              await AuthService.logout();
                              window.location.reload();
                          }}/>
        </StyledHeader>
    );
}

const StyledHeader = styled('header')`
  height: 80px;
  width: 100%;
  display: flex;
  background: #FFF;
  border-bottom: 1px solid #E6E6E6;
`;

const StyledBoxHeader = styled(Box)`
  padding: 0 1.5rem;
`;

const StyledMenuItem = styled(MenuItem)`
  flex-direction: row;
  color: ${Colors.neutral50};

  svg {
    margin-right: 10px;
  }
`;

const StyledPublisherLogo = styled('img')`
  height: 42px;
  cursor: pointer;
`;

const StyledAuthorLogo = styled('img')`
  height: 42px;
  border-radius: 32px;
  cursor: pointer;
`;

const StyledLangValue = styled('p')`
  color: #000;
  margin: 0 10px;
  cursor: pointer;
  text-transform: uppercase;
`;

const StyledNotificationP = styled('p')`
  margin: 0;
  width: 400px;
  font-size: 0.9rem;
  padding: 1rem 0;
`;

const StyledMenuContainer = styled(Grid)`
  padding: 0 10px;
  border-bottom: 1px solid #ccc;
  flex-wrap: nowrap !important;
  cursor: pointer;

  &:last-child {
    border-bottom: 0px;
  }
`;

const StyledCircleGrid = styled(Grid)`
  align-self: center;
  padding-right: 10px;
  min-width: 20px;
`;

const StyledCircleIcon = styled('div')`
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background-color: ${Colors.red};
`;
